import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';

export class Step658608Meta extends BaseModel {
  hasFormerSpouse?: boolean;

  constructor(model: Partial<Step658608Meta> = {}) {
    super();
    this.hasFormerSpouse = model.hasFormerSpouse;
  }
}
